import { useEffect, useState } from "react";
import { CustomerData, LedgerItem } from "../../types";
import api from "../../../../../features/auth/axiosConfig";

export const useLedgerFetch = (
  customerId: string,
  page: number,
  rowsPerPage: number,
  includeHistory: boolean,
  sortField: string,
  sortOrder: "asc" | "desc"
) => {
  const [customerData, setCustomerData] = useState<CustomerData | null>(null);
  const [loading, setLoading] = useState(false);
  const [paginationData, setPaginationData] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: page,
    pageSize: rowsPerPage,
    includeHistory,
    sortField,
    sortOrder,
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/pos/ledger/customer/${customerId}`, {
        params: {
          pageNumber: page,
          pageSize: rowsPerPage,
          includeHistory,
          sortField,
          sortOrder,
        },
      });

      const responseData = res.data;

      if (responseData) {
        const ledgerArray: LedgerItem[] = Array.isArray(responseData.ledger)
          ? responseData.ledger
          : responseData.ledger
          ? [responseData.ledger]
          : [];

        responseData.ledger = ledgerArray;
        setCustomerData(responseData);

        const totalRecords =
          typeof responseData.totalRecords === "number"
            ? responseData.totalRecords
            : ledgerArray.reduce(
                (acc, entry) => acc + (entry.OrderDetails?.length || 0),
                0
              );

        setPaginationData({
          totalRecords,
          totalPages: Math.ceil(totalRecords / rowsPerPage),
          currentPage: page,
          pageSize: rowsPerPage,
          includeHistory,
          sortField,
          sortOrder,
        });
      }
    } catch (error) {
      console.error("Error fetching ledger data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [customerId, page, rowsPerPage, includeHistory, sortField, sortOrder]);

  return { customerData, paginationData, loading, refetch: fetchData };
};

